const FETCH_RAISE_NDTYPES_REQUEST = "FETCH_RAISE_NDTYPES_REQUEST";
const FETCH_RAISE_NDTYPES_SUCCESS = "FETCH_RAISE_NDTYPES_SUCCESS";
const FETCH_RAISE_NDTYPES_FAILURE = "FETCH_RAISE_NDTYPES_FAILURE";

export default {
  FETCH_RAISE_NDTYPES_REQUEST,
  FETCH_RAISE_NDTYPES_SUCCESS,
  FETCH_RAISE_NDTYPES_FAILURE,
};
